var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { Button, Form, FormGroup, FormFeedback, Label, Input, InputGroup, InputGroupAddon, InputGroupText, CustomInput, Modal, ModalHeader, ModalBody, ModalFooter, Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import { Card, CardTitle, CardText, CardBody, Row, Col, Container } from 'reactstrap';

import reactCSS from 'reactcss';
import { BlockPicker } from 'react-color';

var logdown = require('logdown');
var console = logdown('rx-forms-rx-color', { prefixColor: '#e91e63' });

var RXColor = function (_Component) {
  _inherits(RXColor, _Component);

  function RXColor(props) {
    _classCallCheck(this, RXColor);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.onChange = function (color) {

      _this.setState({ value: color.hex, displayColorPicker: false }, function () {
        _this.props.onChange({ target: { value: _this.state.value, id: _this.props.name } });
      });
    };

    _this.handleClick = function () {
      _this.setState({ displayColorPicker: !_this.state.displayColorPicker });
    };

    _this.handleClose = function () {
      _this.setState({ displayColorPicker: false });
    };

    _this.handleChange = function (color) {
      console.log('color: ', color.hex);
      _this.setState({ color: color.rgb });
    };

    console.log('13000: ', _this.props);

    var value = _this.props.value && _this.props.value != "" ? _this.props.value : "#697689";
    console.log('13001: value: ', value);
    _this.state = {
      invalid: false,
      value: value,
      displayColorPicker: false
    };

    return _this;
  }

  RXColor.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {

    if (this.props.value != prevProps.value) {
      this.setState({ value: this.props.value });
    }
  };

  RXColor.prototype.render = function render() {
    var _props = _extends({}, this.props),
        props = _props.props,
        value = _props.value;

    var styles = reactCSS({
      'default': {
        color: {
          width: '36px',
          height: '14px',
          borderRadius: '2px',
          background: '' + this.state.value
        },
        swatch: {
          padding: '5px',
          background: '#fff',
          borderRadius: '1px',
          boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
          display: 'inline-block',
          cursor: 'pointer'
        },
        popover: {
          position: 'absolute',
          zIndex: '2',
          marginLeft: '-61px'
        },
        cover: {
          position: 'fixed',
          top: '0px',
          right: '0px',
          bottom: '0px',
          left: '0px'
        }
      }
    });

    return React.createElement(
      React.Fragment,
      null,
      React.createElement(
        'div',
        null,
        React.createElement(
          'div',
          { style: styles.swatch, onClick: this.handleClick },
          React.createElement('div', { style: styles.color })
        ),
        this.state.displayColorPicker ? React.createElement(
          'div',
          { style: styles.popover },
          React.createElement('div', { style: styles.cover, onClick: this.handleClose }),
          React.createElement(BlockPicker, { color: this.state.value, onChange: this.onChange })
        ) : null
      ),
      this.state.invalid && React.createElement(
        'div',
        { className: 'text-danger small' },
        this.props.feedbackMessage
      )
    );
  };

  return RXColor;
}(Component);

export default RXColor;